import { useEffect, useState } from "react";

export const useChatHistory = (token: string | null) => {
  const [messages, setMessages] = useState([]);
  const [questionCount, setQuestionCount] = useState(0);
  const [lastQuestionDate, setLastQuestionDate] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!token) return;

    const fetchHistory = async () => {
      try {
        const res = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/get-chat-history`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        const data = await res.json();

        setMessages(data.messages ?? []);
        setQuestionCount(data.daily_question_count ?? 0);
        setLastQuestionDate(data.last_question_date ?? null);
      } catch (err) {
        console.error("Failed to load chat history:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchHistory();
  }, [token]);

  return { messages, questionCount, lastQuestionDate, isLoading, setMessages, setQuestionCount, setLastQuestionDate };
};
